import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  getPerformanceNow,
  recordDashboardPerformanceMetric
} from 'helpers/performance'

const useRoutePerformance = () => {
  const location = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    const route = `${location.pathname}${location.search}`
    const start = getPerformanceNow()
    const markStart = `dashboard-route-start:${route}:${start}`
    const markEnd = `dashboard-route-end:${route}:${start}`
    let firstFrame
    let secondFrame

    window.performance?.mark?.(markStart)

    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => {
        const duration = getPerformanceNow() - start
        window.performance?.mark?.(markEnd)
        window.performance?.measure?.(
          'dashboard-route-render',
          markStart,
          markEnd
        )
        recordDashboardPerformanceMetric({
          name: 'route-render',
          detail: { route },
          duration
        })
      })
    })

    return () => {
      window.cancelAnimationFrame(firstFrame)
      window.cancelAnimationFrame(secondFrame)
    }
  }, [location.pathname, location.search])
}

export default useRoutePerformance
